var _g, _path, _path2, _path3, _path4, _path5, _path6, _circle, _g2, _g3, _path7, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgK700Vector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#363c42"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 757.21,
    cy: 379,
    rx: 228.48,
    ry: 223
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 464.29,
    cy: 379,
    rx: 228.48,
    ry: 223
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M616.3 1078.25l-2.05-864c-276.71 21-310.53 102-310.53 102-40.99 107-44.07 502-44.07 502 103.51 283 356.51 259.5 356.51 259.5l-1.01-1s244 24.5 345-258.5c0 0-3-395-43-502 0 0-33-81-303-102v860",
    fill: "#007cbd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M611.35 1076.25s261 8 345-259c0 0 13-107-42-200l-263-295h-79l-260.65 294s-61.61 58-47.48 201c0 0 61.13 257 347.13 259z",
    fill: "none",
    stroke: "#005b8e",
    strokeWidth: 11,
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M592.14 234.25h35.52c14.49 0 26.24 11.75 26.24 26.24v36.02c0 14.49-11.75 26.24-26.24 26.24h-35.52c-14.49 0-26.24-11.75-26.24-26.24v-36.02c0-14.49 11.75-26.24 26.24-26.24z",
    fill: "#363c42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M583.9 385.75h52c14.64 0 26.5 11.86 26.5 26.5v127c0 14.64-11.86 26.5-26.5 26.5h-52c-14.64 0-26.5-11.86-26.5-26.5v-127c0-14.64 11.86-26.5 26.5-26.5z",
    fill: "#b7b7b7",
    stroke: "#fff",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M550.67 1005.25h120.67a13.17 13.17 0 0 1 13.17 13.17v14.67a13.17 13.17 0 0 1-13.17 13.17H550.67a13.17 13.17 0 0 1-13.17-13.17v-14.67c0-7.28 5.89-13.17 13.17-13.17z",
    fill: "#005b8e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M568.5 963.25h85a12 12 0 0 1 12 12v4a12 12 0 0 1-12 12h-85a12 12 0 0 1-12-12v-4a12 12 0 0 1 12-12z",
    fill: "#b7b7b7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 609.9,
    cy: 435.25,
    r: 32,
    fill: "#c13e3e"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#363c42"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 642.25,
    cy: 500.75,
    r: 6.5,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 609.9,
    cy: 500.75,
    r: 6.5,
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.25,
    cy: 500.75,
    r: 6.5,
    opacity: 0.98
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 642.25,
    cy: 535.75,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 609.9,
    cy: 540.25,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.25,
    cy: 535.75,
    r: 12
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M561 227.25h0c2.34-2.34 6.14-2.34 8.49 0L590 247.76c2.34 2.34 2.34 6.14 0 8.49h0c-2.34 2.34-6.14 2.34-8.49 0L561 235.74c-2.34-2.34-2.34-6.14 0-8.49zm99 0h0c2.34 2.34 2.34 6.14 0 8.49l-20.51 20.51c-2.34 2.34-6.14 2.34-8.49 0h0c-2.34-2.34-2.34-6.14 0-8.49l20.51-20.51c2.34-2.34 6.14-2.34 8.49 0z",
    fill: "#363c42"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffb30b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 642.47,
    cy: 977.26,
    r: 9.38,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.92,
    cy: 977.26,
    r: 9.38,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 599.58,
    cy: 977.26,
    r: 9.38,
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.88,
    cy: 977.26,
    r: 9.38,
    opacity: 0.51
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgK700Vector);
export default __webpack_public_path__ + "static/media/K700_Vector.2f0a11ccfc128807ee30faff23b1b7d3.svg";
export { ForwardRef as ReactComponent };